import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import useSWR from "swr";

import { useState } from "react";

import classNames from "classnames";

import Button from "components/Button";
import CustomCard from "components/CustomCard";
import ProfileSnippet from "components/ProfileSnippet";
import useSignInSignUp from "components/SignInSignUpModal/useSignInSignUp";
import useAuthentication from "hooks/useAuthentication";
import useMediaQuery from "hooks/useMediaQuery";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

import styles from "./style.module.scss";

const ContactIRModal = dynamic(() => import("components/ContactIRModal"));

type EntityPageInvestorRelationsProps = { card?: boolean; widget?: boolean };

export const entityCorporateOfficersUrl = (slug: string, pageIndex: number) => {
  const url = new ApiEndpoint(`/api/v2/entities/${slug}/corporate-officers`);
  url.searchParams.append("include", "company");
  url.searchParams.append("page[size]", "5");
  url.searchParams.append("page[number]", `${pageIndex}`);

  return url.href;
};

const EntityPageInvestorRelations = ({
  card,
  widget,
}: EntityPageInvestorRelationsProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;

  const { toggleModal } = useSignInSignUp();
  const { mobile } = useMediaQuery();
  const { authenticated } = useAuthentication();

  const { data } = useSWR(entityCorporateOfficersUrl(slug, 1), baseFetcher);

  const [showContactIRModal, toggleContactIRModal] = useState(false);
  const [defaultProfile, setDefaultProfile] = useState(null);

  if (!data?.data?.length) return <></>;

  const content = (
    <div
      className={classNames(styles.container, mobile && styles.mobileLayout)}
    >
      <div className={styles.title}>
        Investor Relations
        <Button
          className={styles.contactIR}
          onClick={() =>
            authenticated
              ? toggleContactIRModal(!showContactIRModal)
              : toggleModal("sign-in")
          }
        >
          Contact IR
        </Button>
      </div>
      <div className={classNames(styles.list, card && styles.card)}>
        {data?.data?.map?.((profile: any) => (
          <ProfileSnippet
            key={profile.id}
            profile={profile}
            card={card}
            onContactIR={() => {
              if (authenticated) {
                setDefaultProfile(profile);
                toggleContactIRModal(!showContactIRModal);
                return;
              }

              toggleModal("sign-in");
            }}
          />
        ))}
      </div>
      {showContactIRModal && (
        <ContactIRModal
          profiles={data?.data}
          defaultProfile={defaultProfile}
          onClose={() => {
            toggleContactIRModal(!showContactIRModal);
            setDefaultProfile(null);
          }}
        />
      )}
    </div>
  );

  if (widget) {
    return <CustomCard className={styles.card}>{content}</CustomCard>;
  }

  return content;
};

export default EntityPageInvestorRelations;
